<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="活动名称：" prop="activityName">
            <el-input style="width: 424px;" v-model="ruleForm.activityName" placeholder="请输入活动名称"></el-input>
          </el-form-item>
          <el-form-item label="活动时间：" prop="activityTime">
            <el-date-picker
              v-model="activityTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveCouponActivityCenter, fetchCouponActivityCenterDetailById, updateCouponActivityCenter } from '@/api/coupon'
export default {
  name: 'CouponCenterAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      dataId: this.$route.query.dataId,
      activityTime:['',''],
      ruleForm: {
        activityName:'',
        activityTime:['',''],
        sort:'',
        status: false
      },
      rules: {
        activityName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        activityTime: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    if (this.$route.query.dataId != '') {
      let that = this
      fetchCouponActivityCenterDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.activityName = data.activityName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.activityTime = [data.activityStartTime,data.activityEndTime]
          that.activityTime = [data.activityStartTime,data.activityEndTime]
          that.ruleForm.sort = data.sort
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let activityName = that.ruleForm.activityName
      let activityTime = that.activityTime
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      let status = that.ruleForm.status ? 1 : 0
      if (activityName === '') {
        this.$message.error('请输入活动名称')
        return false
      }
      if (activityTime[0] === '') {
        this.$message.error('请选择活动时间')
        return false
      }
      let passData = {
        activityName: activityName, activityStartTime: activityTime[0], activityEndTime: activityTime[1], sort: sort, status: status
      }
      if (dataId !== '') {
        passData.id = dataId;
        updateCouponActivityCenter(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveCouponActivityCenter(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/coupon/CouponCenterAdd.vue